module.exports = __webpack_public_path__ + "img/spmap.f93db1ae.svg";